(function(){
	'use strict';
	angular
	.module('app')
	.controller('MainController', MainController);
	function MainController($timeout, $scope, $rootScope, API, config, $location, $analytics, $state){
		let vm = this;
		$rootScope.tipoSolucao = 0;
		$rootScope.baseUrl = config.baseUrl;
		$rootScope.urlUpload = config.urlUpload;
		$rootScope.hashUpload = config.hashUpload;
		vm.sendFooter = sendFooter;
		vm.textButton = "Enviar";
		vm.enviado = false;
		
		vm.$onInit = () => {
			vm.loading();
			getFromAPI();
			vm.menulateralZ = '-1';
			vm.mostraMenu = false;
			vm.bg = 'transparent';
			vm.ScrollPath();
			pageCheck($location.url());
		}
		
		$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
			vm.ScrollPath();
			$analytics.pageTrack($location.url());
			pageCheck($location.url());
			vm.loading();
			vm.scrollEffectTop();
		});

		function pageCheck(page) {
			vm.internal = true;
			page = page.split('/');
			page = page[1];
			switch(page) {
				case 'institucional':
					vm.institutional = true;
					vm.solutions = false;
					vm.usefulLinks = false;
					vm.blog = false;
					vm.contact = false;
					vm.clientes = false;
				break;
				case 'solucoes':
					vm.solutions = true;
					vm.institutional = false;
					vm.usefulLinks = false;
					vm.blog = false;
					vm.contact = false;
					vm.clientes = false;
				break;
				case 'links-uteis':
					vm.usefulLinks = true;
					vm.institutional = false;
					vm.solutions = false;
					vm.blog = false;
					vm.contact = false;
					vm.clientes = false;
				break;
				case 'blog':
					vm.blog = true;
					vm.institutional = false;
					vm.solutions = false;
					vm.usefulLinks = false;
					vm.contact = false;
					vm.clientes = false;
				break;
				case 'contato':
					vm.contact = true;
					vm.institutional = false;
					vm.solutions = false;
					vm.usefulLinks = false;
					vm.blog = false;
					vm.clientes = false;
				break;
				case 'clientes':
					vm.clientes = true;
					vm.contact = false;
					vm.institutional = false;
					vm.solutions = false;
					vm.usefulLinks = false;
					vm.blog = false;
				break;
				default:
					vm.institutional = false;
					vm.solutions = false;
					vm.usefulLinks = false;
					vm.blog = false;
					vm.contact = false;
					vm.internal = false;
					vm.clientes = false;
				break;
			}
		}
		
		vm.loading = function () {
			$(".loading").show();
			$(".loading").delay(2000).fadeOut("slow");
		};
		
		vm.ScrollPath = function () {
			vm.url = $state.current.name;
			vm.local = $location.path().split('/')[1];
			$timeout(function () {
				if ($location.path() != '/') {
					$("html, body").animate({
						scrollTop: 0
					}, 300);
				} else {
					$("html, body").animate({
						scrollTop: 0
					}, 300);
				}
			});
		}

		window.onscroll = function() {
			vm.scrollEffectTop()
		};

		vm.openMenu =() =>{
			vm.menulateralZ = '70';
			vm.bg = 'rgba(0,0,0,0.2)';
			vm.op = '1';
		}
		vm.closeMenu =() =>{
			$timeout(function() {
				vm.menulateralZ = '-1';
				vm.bg = 'transparent';
			}, 300);
		}

		function getFromAPI() {
			API.get('configuracao/sociais').then(result => {
				vm.redesSociais = result.data[0];
			});
			API.get('endereco').then(result => {
				vm.endereco = result.data[0];
			});
		}

		vm.abre_menu_m = function(){
			$scope.menuOpen = true;
		}

		function sendFooter(data){
			API.post('receiveNews', data);
			vm.textButton = "Enviando";
			vm.isSending = true;
			vm.buttonStyle = {
				cursor: 'not-allowed',
				opacity: '0.7'
			};
			$timeout(() => {
				vm.dado.email = '';
				vm.dado.nome = '';
				vm.enviado = true;
				vm.textButton = "Enviado :)";
				vm.buttonStyle = {
					cursor: 'pointer',
					opacity: '1'
				};
				vm.isSending = false;
			}, 2000)
			$timeout(() => {
				vm.enviado = false;
				vm.textButton = "Enviar";
				vm.isSending = false;
			}, 7000)
		}


		vm.scrollEffectTop =() =>{
			var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
			var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
			var scrolled = (winScroll / height) * 100;
			document.getElementById("progress-bar").style.width = scrolled + "%";
		}
	} //fim main
})();